import { combineReducers } from "redux";
import axios from "axios";
import _ from 'lodash';
import { API } from "../../../../../../const";
import { fetchKids } from "../../../Kids-list.ducks";
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
import { getPlanningSimple } from "../../../fiche-enfant/les-tabs-ducks/Planning.ducks"

// Absence actions

export const POST_ABSENCE_PENDING = "POST_ABSENCE_PENDING";
export const POST_ABSENCE_REJECTED = "POST_ABSENCE_REJECTED";
export const POST_ABSENCE_FULFILLED = "POST_ABSENCE_FULFILLED";

export const GET_ABSENCE_PENDING = "GET_ABSENCE_PENDING";
export const GET_ABSENCE_REJECTED = "GET_ABSENCE_REJECTED";
export const GET_ABSENCE_FULFILLED = "GET_ABSENCE_FULFILLED";

export const PUT_ABSENCE_PENDING = "PUT_ABSENCE_PENDING";
export const PUT_ABSENCE_REJECTED = "PUT_ABSENCE_REJECTED";
export const PUT_ABSENCE_FULFILLED = "PUT_ABSENCE_FULFILLED";

export const DELETE_ABSENCE_PENDING = "DELETE_ABSENCE_PENDING";
export const DELETE_ABSENCE_REJECTED = "DELETE_ABSENCE_REJECTED";
export const DELETE_ABSENCE_FULFILLED = "DELETE_ABSENCE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_ABSENCE_PENDING:
    case GET_ABSENCE_PENDING:
    case PUT_ABSENCE_PENDING:
    case DELETE_ABSENCE_PENDING:

      return true;
    case POST_ABSENCE_REJECTED:
    case POST_ABSENCE_FULFILLED:
    case GET_ABSENCE_REJECTED:
    case GET_ABSENCE_FULFILLED:
    case PUT_ABSENCE_REJECTED:
    case PUT_ABSENCE_FULFILLED:
    case DELETE_ABSENCE_REJECTED:
    case DELETE_ABSENCE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ABSENCE_PENDING:
    case POST_ABSENCE_FULFILLED:
    case GET_ABSENCE_PENDING:
    case GET_ABSENCE_FULFILLED:
    case PUT_ABSENCE_PENDING:
    case PUT_ABSENCE_FULFILLED:
    case DELETE_ABSENCE_PENDING:
    case DELETE_ABSENCE_FULFILLED:
      return null;
    case POST_ABSENCE_REJECTED:
    case GET_ABSENCE_REJECTED:
    case PUT_ABSENCE_REJECTED:
    case DELETE_ABSENCE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ABSENCE_FULFILLED:
    case GET_ABSENCE_FULFILLED:
    case PUT_ABSENCE_FULFILLED:
    case DELETE_ABSENCE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    case POST_ABSENCE_PENDING:
    case GET_ABSENCE_PENDING:
    case PUT_ABSENCE_PENDING:
    case DELETE_ABSENCE_PENDING:
      return null;
    case POST_ABSENCE_REJECTED:
    case GET_ABSENCE_REJECTED:
    case PUT_ABSENCE_REJECTED:
    case DELETE_ABSENCE_REJECTED:
      return null;

    default:
      return state;
  }
};

// Absence reducer
export default combineReducers({ loading, error, data });

export const postAbsenceSimple = (tok, idKid, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${idKid}/calendrier/absences`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_ABSENCE_FULFILLED, payload: res })
      dispatch(getPlanningSimple(tok, idKid))
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_ABSENCE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}
export const getAbsenceEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/agendas/timeline/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_ABSENCE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_ABSENCE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const updateAbsenceEvent = (tok, idEvent, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/agendas/statut/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_ABSENCE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_ABSENCE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const deleteAbsenceEvent = (tok, id, idKid) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/enfants/calendrier/absences/${id}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_ABSENCE_FULFILLED, payload: res })
      dispatch(getPlanningSimple(tok, idKid))
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_ABSENCE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
